import { useTranslation } from "react-i18next";
import { NavigationItem, ProcessStep } from "../navigation";

export const OrderNavi = ({ items, active }: { items: NavigationItem[]; active: ProcessStep }) => {
	const { t } = useTranslation();

	return (
		<div className="row space-t" id="order-nav">
			<div className="col-md-12">
				<div className="order-nav">
					{items.map((i) => (
						<div className={`order-nav-item${active === i.step ? " active" : ""}`}>
							<p>{t(i.text)}</p>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
